import { Flex, Spin } from "@ir/ui";
import { Activity, memo } from "react";

const ApprovalsLoadingSpinner = memo(({ isVisible }: { isVisible: boolean }) => (
    <Activity name="approvals-loading" mode={isVisible ? "visible" : "hidden"}>
      <Flex align="center" justifyContent="center" className="h-100">
        <Spin spinning aria-label="Large Spin" />
      </Flex>
    </Activity>
  ));
  ApprovalsLoadingSpinner.displayName = "ApprovalsLoadingSpinner";

export { ApprovalsLoadingSpinner };